export function isStringArray(value: any): value is string[] {
  if (Array.isArray(value)) {
    return typeof value[0] === 'string';
  } else {
    return false;
  }
}
